import { Component, JSX, Show } from 'solid-js';
import { TreeAction, TreeActionProps } from './TreeAction';
import { Spinner } from '../spinner/Spinner';

interface LoadableTreeActionProps extends TreeActionProps {
  isLoading: boolean;
  onCancelClick?(): void;
}

export const LoadableTreeAction: Component<LoadableTreeActionProps> = (
  props
): JSX.Element => {
  return (
    <Show
      when={!props.isLoading}
      fallback={
        <>
          <span
            data-testid="loadable-tree-action-spinner"
            class="w-10 flex justify-center"
          >
            <Spinner
              color="var(--modus-wc-color-primary)"
              onCancel={props.onCancelClick}
            />
          </span>
        </>
      }
    >
      <TreeAction
        label={props.label}
        icon={props.icon}
        class={props.class}
        disabled={props.disabled}
        onClick={props.onClick}
      />
    </Show>
  );
};

export default LoadableTreeAction;
